
import React from "react";
import {PropTypes} from "prop-types";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
const AdminRoutes = (props) => {
  const { user } = useSelector((state) => state.AuthReducer);
  return user.isAdmin ? (
    <Route path={props.path} exact={props.exact} component={props.component} />
  ) : (
    <Redirect to="/" from="/skills" />
  );
};
AdminRoutes.propTypes = {
  path: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  component: PropTypes.func,
};
export default AdminRoutes;
